import { GRID_SIZE } from '../constants/config';

function scoreToEmoji(score) {
  if (score < 1) return '\u2B1C';
  if (score < 2.5) return '\uD83D\uDFE5';
  if (score < 4) return '\uD83D\uDFE7';
  if (score < 6.5) return '\uD83D\uDFE8';
  if (score < 8.5) return '\uD83D\uDFE9';
  return '\uD83D\uDFE6';
}

export function generateShareText(grid, totalScore, puzzleNumber, retryCount, protestResults) {
  let text = `Approximate Grid`;
  if (puzzleNumber) text += ` #${puzzleNumber}`;
  text += `  ${totalScore.toFixed(1)}\n\n`;

  for (let row = 0; row < GRID_SIZE; row++) {
    const rowEmojis = [];
    for (let col = 0; col < GRID_SIZE; col++) {
      rowEmojis.push(scoreToEmoji(grid[row][col].finalScore));
    }
    text += rowEmojis.join('') + '\n';
  }

  const parts = [];
  parts.push(`\uD83D\uDD04 ${retryCount || 0}`);
  if (protestResults && protestResults.length > 0) {
    const accepted = protestResults.filter(p => p.accepted);
    const totalChange = accepted.reduce((sum, p) => sum + p.scoreChange, 0);
    if (accepted.length > 0 && totalChange > 0) {
      parts.push(`\u2696\uFE0F +${Math.round(totalChange)}`);
    } else if (accepted.length > 0) {
      parts.push(`\u2696\uFE0F accepted`);
    } else {
      parts.push(`\u2696\uFE0F denied`);
    }
  } else {
    parts.push(`\u2696\uFE0F unused`);
  }
  text += '\n' + parts.join(' | ') + '\n';

  text += '\nhttps://approximategrid.com/';
  return text;
}
